// document.querySelectorAll('.product-sample').forEach(function(sample) {
//     sample.addEventListener('click', function(e) {
//         this.querySelector('button[name="add"]').click();
//     });
// });

function AddSampleToCart(obj) {
    obj.querySelector('button[name="add"]').click();
}

document.querySelectorAll('.button--ordersample').forEach(function(ordersample) {
    ordersample.addEventListener('click', function(e) {
        e.preventDefault();

        let old_value = $('#form-variant-id').val();
        $('#form-variant-id').val(this.getAttribute('data-variantid'));
        $('.product-form__submit').click();
        $('#form-variant-id').val(old_value);
    });
});

function getQuote(){
    Swal.fire({
        html:   '<form method="post" id="frm_send_quote">' + 
                    '<h3 class="heading h3">Save Quote</h3>' + 
                    '<div class="field">' +
                        '<input id="input_email" type="email" name="contact[email]" class="field__input" aria-required="true" autocorrect="off" autocapitalize="off" autocomplete="email" placeholder="Email" value="'+atob(customer_email)+'" required>' +
                        '<label class="field__label" for="input_email">Email</label>' +
                    '</div><br><br>' + 
                    '<button type="submit" id="btn_send_quote" class="cart__checkout-button button">Send</button>' +
                    '<h4 class="heading h4" id="txt_processing" style="display: none;">Processing...</h4>' + 
                '</form>',
        showConfirmButton: false,
    });

    $("#frm_send_quote").on("submit", function(e){
        e.preventDefault();
    
        $("#btn_send_quote").remove();
        $("#txt_processing").css("display", "block");

        let email = $("#input_email").val();

        $.ajax({
            url: "/cart.json",
            method: "get",
            success: function(data) {
                data.email = email;
                let cart_data = JSON.stringify(data);

                $.ajax({
                    url: "/apps/hpb/api/quote",
                    method: "POST",
                    data: cart_data,
                    dataType: "text",
                    success: function(data) {
                        if(data == 'ok'){
                            Swal.fire({
                                title: '<h4 style="line-height: 100%; font-size: 25px; margin-top: 20px;">'+quote_success_title+'</h4>',
                                text: quote_success_message,
                                showConfirmButton: true,
                                confirmButtonText: 'Close',
                                confirmButtonColor: '#A4B65C',
                                allowOutsideClick: false
                            });
                        }
                        else if(data == 'ok but'){
                            Swal.fire({
                                title: '<h4 style="line-height: 100%; font-size: 25px; margin-top: 20px;">Oops!</h4>',
                                text: 'Your cart only contains sample(s).',
                                showConfirmButton: true,
                                confirmButtonText: 'Close',
                                confirmButtonColor: '#A4B65C',
                                allowOutsideClick: false
                            });
                        }
                        else{
                            Swal.fire({
                                title: '<h4 style="line-height: 100%; font-size: 25px; margin-top: 20px;">Oops!</h4>',
                                text: 'There is an error encountered in processing your request. Please try again later. (Code: '+data+')',
                                showConfirmButton: true,
                                confirmButtonText: 'Close',
                                confirmButtonColor: '#A4B65C',
                                allowOutsideClick: false
                            })
                        }
                    }
                }); 

            }
        });
    });
}


document.querySelectorAll('.dummy-atc').forEach(function(sample) {
    sample.addEventListener('click', function(e) {
        e.preventDefault();
        if (!sample.classList.contains('soldout-button')) {
            if (document.getElementById('calc-button-submit') != null) {
            document.getElementById('calc-button-submit').click();
            }
        }
    });
});

document.querySelectorAll('.rte iframe').forEach(function(vid) {
    vid.parentElement.style.paddingTop = "56.25%";
});
